import React, { useEffect, useState } from "react";
import {
  Paper,
  Box,
  Typography,
  Table,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import FilledButton from "../../components/Common/FilledButton";
import TableHeader1 from "../../components/Common/TableHeader1";
import UserManagementTableBody3 from "../../components/Common/UserManagementTableBody3";
import useApi from "../../service/api.service";
import toast, { Toaster } from "react-hot-toast";

function Configuration() {
  const styles = {
    mainPaperStyle: {
      width: "40%",
      boxShadow: "none",
      border: "1px solid #E4E4E4",
      borderRadius: "10px",
      minWidth: "550px",
    },
    box1Style: {
      display: "flex",
      justifyContent: "space-between",
      p: 2,
      borderBottom: "1px solid #E4E4E4",
      alignItems: "center",
    },
  };

  const [tableData, setTableData] = useState({
    columns: ["Factors", "Lower Limit", "Upper Limit"],
    rows: [],
  });

  const API = useApi();
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [factorsData, setFactorsData] = useState(null);

  useEffect(() => {
    getFactorsData();
  }, []);

  const getFactorsData = async () => {
    const requestBodyParams = {
      startTime: null,
      endTime: null,
    };
    try {
      setLoading1(true);
      const response = await API.getConfigurationData();
      setLoading1(false);
      setFactorsData(response.data);

      const newRows = response.data.map((factor) => ({
        id: factor.factorId,
        factor: factor.factorName,
        lower: factor.lowerLimit,
        upper: factor.upperLimit,
      }));

      setTableData((prevTableData) => ({
        ...prevTableData,
        rows: newRows,
      }));
    } catch (error) {
      setLoading1(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e, rowIndex, columnName) => {
    let value = e.target.value;
    if (value === "") {
      value = null;
    }
    if (value !== null && isNaN(value)) {
      toast.error("Limits must be a number");
      return;
    }
    const updatedRows = [...tableData.rows];
    updatedRows[rowIndex][columnName] = value;
    setTableData({ ...tableData, rows: updatedRows });
  };

  const validateData = () => {
    const valid = tableData.rows.every((row) => {
      const lower = row.lower ? row.lower.toString().trim() : "";
      const upper = row.upper ? row.upper.toString().trim() : "";
      if (lower === "" || upper === "") {
        return true;
      }
      return parseFloat(lower) < parseFloat(upper);
    });

    if (!valid) {
      throw new Error("Lower Limit must be less than Upper Limit.");
    }
  };

  const handleSave = async () => {
    try {
      setLoading2(true);

      validateData();

      // Get initial table data state
      const initialRows = factorsData.map((factor) => ({
        id: factor.factorId,
        factor: factor.factorName,
        lower: factor.lowerLimit,
        upper: factor.upperLimit,
      }));

      // Prepare payload with only changed rows
      const payload = tableData.rows.map((currentRow, index) => {
        const initialRow = initialRows[index];
        const changedData = {};

        if (currentRow.lower !== initialRow.lower) {
          changedData.lowerLimit = currentRow.lower;
        }

        if (currentRow.upper !== initialRow.upper) {
          changedData.upperLimit = currentRow.upper;
        }

        // Include factorId only if there are changes
        if (Object.keys(changedData).length > 0) {
          changedData.factorId = currentRow.id;
        }

        return changedData;
      });

      // Filter out rows with no changes
      const filteredPayload = payload.filter(
        (data) => Object.keys(data).length > 1
      );

      if (filteredPayload.length === 0) {
        throw new Error("No factors to update.");
      }

      await API.updateConfigurationData(filteredPayload);
      toast.success("Info Updated Successfully");
      getFactorsData();
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      toast.error(error?.message || "Failed to update info.");
    }
  };

  return (
    <div style={{ height: "82vh", padding: "20px" }}>
      <Paper sx={styles.mainPaperStyle}>
        <Box sx={styles.box1Style}>
          <Box>
            <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
              Contributing Factors Control Limits
            </Typography>
            {/* <p style={{ color: "#C9C9C9", fontSize: "10px" }}>
              Updated 3 minutes ago
            </p> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <FilledButton
              color={"#0077B6"}
              btnname={"Update"}
              onClick={handleSave}
              width={"100px"}
            />
          </Box>
        </Box>
        <Box>
          <TableContainer
            sx={{
              width: "100%",
              maxHeight: "70vh",
              overflowX: "auto",
            }}
          >
            <Table aria-label="simple table" stickyHeader>
              <TableHeader1 tableData={tableData} />
              <UserManagementTableBody3
                tableData={tableData}
                setTableData={setTableData}
                handleInputChange={handleInputChange}
              />
            </Table>
          </TableContainer>
          <Toaster />
        </Box>
      </Paper>
    </div>
  );
}

export default Configuration;
